// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","rankingName":"_2WaPuBzk3xMJtEtxLVsEAA","rankingEmployer":"_5NGL4vLdJmH8uFoFFQ7uU"};